<template>
  <div class="invitation-list">
    <div class="invitation-item" v-for="(item, index) in dataList" :key="index">
      <div class="item-top">
        <div class="leftPart">
          <van-tag plain type="success" v-if="item.EvaluateType === 0"
            >评价</van-tag
          >
          <van-tag plain type="danger" v-else>追评</van-tag>
          <span class="orderId"
            >订单编号：{{ item.PlatformOrderID || "----" }}</span
          >
        </div>
        <!--AuditStatus
          待审核 = 0,
          审核通过 = 1,
          审核不通过 = 2,
          审核完结 = 3,
          超时取消 = 4,
          管理员待审核 = 5,
          悄悄通过 = 6
        -->
        <span
          v-if="item.AuditStatus === 0 || item.AuditStatus === 5"
          class="type-text type-pass"
          >待审核</span
        >
        <span
          v-else-if="item.AuditStatus === 1 || item.AuditStatus === 6"
          class="type-text type-pass"
          >审核通过</span
        >
        <span
          v-else-if="item.AuditStatus === 2 || item.AuditStatus === 3"
          class="type-text type-no"
          >审核不通过</span
        >
        <span v-else-if="item.AuditStatus === 4" class="type-text type-no"
          >超时取消</span
        >
        <span v-else class="type-text type-no">待评价</span>
      </div>
      <!-- main -->
      <div class="item-main" @click="entoDetailPage(item.ProductID)">
        <div class="item-main-img">
          <img :src="item.PicUrl" alt="" />
        </div>
        <div class="item-main-right">
          <div class="item-goods-title">
            <div class="title">
              <!-- <span class="platform-tag pdd" v-if="item.ShopType === 2"
                >拼多多</span
              >
              <span class="platform-tag tm" v-if="item.ShopType === 1"
                >天猫</span
              > -->
              <plat-formLogo :shopType="$utils.shopTypeNumChangeToText(item.ShopType)"></plat-formLogo>
              <template>{{ item.Title || "----" }}</template>
            </div>
            <div class="price">￥{{ item.ShowPrice | formatFloat }}</div>
          </div>
          <div class="item-rebate-price">
            已返利：￥{{ item.BuyRebatePrice | formatFloat }}
          </div>
        </div>
      </div>
      <div class="reward-price">
        <span
          v-if="item.AuditStatus === 3 || item.AuditStatus === 4"
          class="reward-btn not"
          >未获得奖励</span
        >
        <span v-else class="reward-btn">评价奖励</span>
        <span>免单卡 x {{ item.RewardFreeCard }}</span>
      </div>
      <!-- 按钮 -->
      <div class="invitation-btn">
        <div class="overTime" v-if="item.AuditStatus === null || item.AuditStatus === 2 || item.AuditStatus === 3">评价超时时间：<br v-if="item.AuditStatus !== null">{{ item.TimeoutStr }}</div>
        <button
          v-if="item.AuditStatus === 0 || item.AuditStatus === 5"
          class="b-btn"
          @click="waitAudit"
        >
          等待审核
        </button>
        <template v-else-if="item.AuditStatus === 1 || item.AuditStatus === 6">
          <button class="b-btn" @click="checkInvitation(item.ID)">
            查看评价
          </button>
          <button class="b-btn" @click="checkReward(item.ID)">查看奖励</button>
        </template>
        <template v-else-if="item.AuditStatus === 2">
          <button class="b-btn" @click="checkReason(item.ID)">查看原因</button>
          <button class="b-btn black" @click="submitAgian({id: item.ID, taskId: item.TaskID})">
            重新提交
          </button>
        </template>
        <button
          v-else-if="item.AuditStatus === 3"
          class="b-btn"
          @click="checkReason(item.ID)"
        >
          查看原因
        </button>
        <button
          v-else-if="item.AuditStatus === 4"
          class="b-btn"
          @click="checkCancelReason"
        >
          查看原因
        </button>
        <button v-else class="b-btn" @click="nowInvitation({id: item.ID, taskId: item.TaskID})">
          立即{{ item.EvaluateType === 0 ? '评价': '追评' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { Tag } from "vant";
export default {
  components: {
    "van-tag": Tag,
  },
  data() {
    return {};
  },
  props: {
    dataList: {
      type: Array,
      require: true,
      default: () => [],
    },
  },
  methods: {
    entoDetailPage(productId) {
      this.$emit("entoDetailPage", productId);
    },
    // 待审核
    waitAudit() {
      this.$emit("waitAudit");
    },
    // 查看评价
    checkInvitation(id) {
      this.$emit("checkInvitation", id);
    },
    // 查看奖励
    checkReward(id) {
      this.$emit("checkReward", id);
    },
    // 查看原因
    checkReason(id) {
      this.$emit("checkReason", id);
    },
    // 查看已取消原因
    checkCancelReason() {
      this.$emit("checkCancelReason");
    },
    // 立即评价
    nowInvitation({id='',taskId=''}) {
      this.$emit("nowInvitation", {
        id,
        taskId
      });
    },
    // 重新提交
    submitAgian({id='',taskId=''}) {
      this.$emit("submitAgian", {
        id,
        taskId
      });
    },
  },
  filters: {
    formatFloat(val) {
      if (!val) {
        return "0.00";
      }
      return Number(val).toFixed(2);
    },
  },
};
</script>

<style scoped lang="scss">
.invitation-list {
  background: #f5f5f5;
}
.invitation-cnt {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f5f5f5;
}
.invitation-item {
  background: #fff;
  font-size: 14px;
  margin-top: 2%;
}
.invitation-item:first-child {
  margin-top: 0;
}
.item-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 2%;
  height: 2.5em;
  line-height: 2.5em;
  color: #999;
  font-size: 14px;
  .leftPart {
    display: flex;
    align-items: center;
    .orderId {
      margin-left: 4px;
    }
  }
}
.type-text {
  font-size: 14px;
}
.type-pass {
  color: #999;
}
.type-no {
  color: #f23030;
}
.item-main {
  display: flex;
  justify-content: flex-start;
  background: #f7f7f7;
  padding: 2% 3%;
  font-size: 14px;
}
.item-main-img {
  flex-shrink: 0;
  height: 8em;
  width: 8em;
}
.item-main-img img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: 5px;
}
.item-main-right {
  flex-grow: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.item-goods-title {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-left: 3%;
}
.item-goods-title .title {
  max-height: 3em;
  line-height: 1.5em;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.item-goods-title .price {
  flex-shrink: 0;
  min-width: 5em;
  margin-left: 20px;
  text-align: right;
}
.item-rebate-price {
  text-align: right;
  color: #999;
}
.reward-price {
  height: 2.5em;
  line-height: 2.5em;
  margin: 0 3%;
  text-align: right;
  /* color: #F23030; */
  border-bottom: 1px solid #eee;
  font-size: 14px;
}
.reward-btn {
  font-size: 12px;
  color: #fff;
  background: #f05c61;
  border-radius: 4px;
  padding: 5px 8px;
  margin-right: 10px;
}
.reward-btn.not {
  background: #888;
}
.invitation-btn {
  height: 55px;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 3%;
}
.invitation-btn .overTime {
  flex: 1;
  color: #999;
  font-size: 14px;
}
.invitation-btn .b-btn {
  width: 90px;
  height: 35px;
  margin: 0;
  margin-left: 3%;
  line-height: 35px;
  font-size: 14px;
  background: #fff;
  color: #333;
  border: 1px solid #333;
  border-radius: 5px;
}
.invitation-btn .b-btn.black {
  background: #333;
  color: #fff;
}
</style>
